export default __webpack_public_path__ + "static/trees-7c62c7b8a4cce85e19ae730676388ddc.webp";